import { render } from "./IconBarGraph.vue?vue&type=template&id=3a488db7&ts=true"
import script from "./IconBarGraph.vue?vue&type=script&lang=ts"
export * from "./IconBarGraph.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__